module.exports = __webpack_public_path__ + "static/media/empty.48373a0f.webp";